import Backbone from 'backbone'

const PageModel = Backbone.Model.extend({
    defaults: {
        number: 1,
        selected: null,
    },
})

export default PageModel
